import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { MenuItem, Typography, Divider } from '@mui/material';
import { PopperMenuList } from './ui/popper-menulist';
import { LoggedInUserPropType } from '@src/components/prop-types/user';

export const UserMenuDropdown = ({ anchorEl, onClose, user, navPages, userNavPages, signOut, loginUrl }) => {
    const mobileNavPages = useMemo(() => navPages.filter(nav => !nav.hideOnMobile), [navPages]);

    return (
        <PopperMenuList anchorEl={anchorEl} onClose={onClose}>
            {mobileNavPages.map(page => (
                <MenuItem
                    key={page.label}
                    component='a'
                    href={page.href}
                    onClick={onClose}
                    sx={{
                        padding: '0 16px',
                        alignItems: 'center',
                        height: 36,
                        display: { xs: 'flex', desktop: 'none' }
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: 400,
                            fontSize: '14px',
                            lineHeight: '24px',
                            letterSpacing: '-0.176px',
                            color: '#333333'
                        }}
                    >
                        {page.label}
                    </Typography>
                </MenuItem>
            ))}

            {(!user || user.Guest) && (
                <>
                    <Divider
                        sx={{
                            marginTop: '0px !important',
                            marginBottom: '0px !important'
                        }}
                    />

                    <MenuItem
                        component='a'
                        href={loginUrl}
                        onClick={onClose}
                        sx={{
                            padding: '0 16px',
                            alignItems: 'center',
                            height: 36
                        }}
                    >
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: '14px',
                                lineHeight: '24px',
                                letterSpacing: '-0.176px',
                                color: '#333333'
                            }}
                        >
                            Register / Sign In
                        </Typography>
                    </MenuItem>
                </>
            )}

            {user && !user.Guest && <Divider sx={{ my: 1, display: { xs: 'flex', desktop: 'none' } }} />}

            {user &&
                !user.Guest &&
                userNavPages.map(navItem => (
                    <MenuItem
                        key={navItem.label}
                        component='a'
                        href={navItem.id !== 'logout' ? navItem.href : null}
                        onClick={navItem.id === 'logout' ? signOut : onClose}
                        sx={{
                            padding: '0 16px',
                            alignItems: 'center',
                            height: 48,
                            ...(navItem.sx ? navItem.sx : {})
                        }}
                    >
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: '14px',
                                lineHeight: '24px',
                                letterSpacing: '-0.176px',
                                color: '#333333'
                            }}
                        >
                            {navItem.label}
                        </Typography>
                    </MenuItem>
                ))}
        </PopperMenuList>
    );
};

UserMenuDropdown.propTypes = {
    anchorEl: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    user: LoggedInUserPropType,
    navPages: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            label: PropTypes.string.isRequired,
            href: PropTypes.string,
            hideOnMobile: PropTypes.bool
        })
    ).isRequired,
    userNavPages: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            href: PropTypes.string,
            sx: PropTypes.object
        })
    ).isRequired,
    signOut: PropTypes.func.isRequired,
    loginUrl: PropTypes.string.isRequired
};
